import { FormDivider } from '@/components/formComponents';
import MultiAccordions from '../MultiAccordions';
import { HireConditionItem } from '../MultiAccordions/MultiAccordions';
import { QUOTE_FORM_CONTENT_QUERYResult } from 'sanity.types';

const QuoteFormLegend = ({
    quoteFormContent,
}: {
    quoteFormContent: QUOTE_FORM_CONTENT_QUERYResult;
}) => {
    return quoteFormContent === null ? null : (
        <div className="flex flex-wrap p-4 mb-8">
            {quoteFormContent[0]?.message && (
                <>
                    <div className="w-full font-bold text-center text-balance">
                        {quoteFormContent[0]?.message}
                    </div>

                    <FormDivider />
                </>
            )}

            {quoteFormContent[0]?.legends &&
                quoteFormContent[0]?.legends.length > 0 && (
                    <MultiAccordions
                        copyData={
                            quoteFormContent[0]?.legends as HireConditionItem[]
                        }
                    />
                )}
        </div>
    );
};

export default QuoteFormLegend;
